import React from 'react';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import {
  ENTRANCE_DOORS_BENEFITS_DATA,
  EntranceDoorsBenefitsStructure,
} from './entrance-doors-benefits-constants';
import { entranceDoorsBenefitsList, entranceDoorsBenefitsText } from './entrance-doors-benefits-styles';

/**
 * Вью секции преимуществ Леруа
 */

export const EntranceDoorsBenefits: React.FC = () => (
  <Section>
    <SectionSubTitle margin="m">Почему Лемана ПРО</SectionSubTitle>
    <ul className={entranceDoorsBenefitsList}>
      {ENTRANCE_DOORS_BENEFITS_DATA.map(({ icon, text }: EntranceDoorsBenefitsStructure, index: number) => (
        <li key={createElementKey('benefits', index)}>
          {icon}
          <Typography className={entranceDoorsBenefitsText} size="body_short" variant="m">
            {text}
          </Typography>
        </li>
      ))}
    </ul>
  </Section>
);
